import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "Search" }
const _hoisted_2 = { class: "searchBar border border-gray-400 rounded-md flex items-center justify-between overflow-hidden" }
const _hoisted_3 = { class: "searchText h-8 w-full" }
const _hoisted_4 = { class: "searchButton w-8 h-8 p-2 bg-emerald-900 rounded-r-md cursor-pointer" }
const _hoisted_5 = {
  key: 0,
  src: "/img/icons/search.svg",
  alt: "Search icon"
}
const _hoisted_6 = {
  key: 0,
  class: "searchBoxContainer fixed top-14 left-0 right-0 bottom-0 pl-8 pr-8 pb-8 -mt-1 bg-white bg-opacity-80"
}
const _hoisted_7 = {
  key: 0,
  class: "products w-full grid grid-cols-2 md:grid-cols-6 gap-8"
}
const _hoisted_8 = { class: "text p-2 flex flex-col gap-1 text-center font-bold" }
const _hoisted_9 = { class: "text-emerald-900 truncate" }
const _hoisted_10 = { class: "text-sm" }
const _hoisted_11 = {
  key: 1,
  class: "products w-full grid grid-cols-2 md:grid-cols-6 gap-8 animate-pulse"
}
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"image bg-gray-300 aspect-square bg-center bg-cover rounded-md\"></div><div class=\"text py-2 flex flex-col gap-1 text-center font-bold\"><p class=\"h-6 bg-gray-300 rounded-md\"></p><p class=\"h-4 bg-gray-300 rounded-md\"></p><p class=\"h-4 bg-gray-300 rounded-md\"></p></div>", 2)
const _hoisted_14 = [
  _hoisted_12
]
const _hoisted_15 = {
  key: 2,
  class: "notFound w-full h-full flex items-center justify-center"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "No hubo resutados para la búsqueda", -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          type: "text",
          class: "h-full w-full px-2 text-xs text-gray-400",
          placeholder: "Buscar producto...",
          ref: "searchInput",
          onKeyup: _cache[0] || (_cache[0] = ($event: any) => (_ctx.search(($event.target as any).value)))
        }, null, 544)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.showSearchBox)
          ? (_openBlock(), _createElementBlock("img", _hoisted_5))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: "/img/icons/x.svg",
              alt: "Search icon",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeSearch()))
            }))
      ])
    ]),
    (_ctx.showSearchBox)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(["searchBox w-full h-full bg-white rounded-lg shadow-xl shadow-gray-300 border p-8 overflow-auto transition-all duration-1000", (_ctx.showSearchBox) ? 'opacity-100' : 'opacity-0'])
          }, [
            (_ctx.products.length > 0 && !_ctx.isSearching)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "productCard overflow-hidden",
                      key: index
                    }, [
                      _createVNode(_component_router_link, {
                        to: '/producto/' + product.id,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeSearch()))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "image bg-gray-300 aspect-square bg-center bg-cover rounded-md",
                            style: _normalizeStyle((product.gallery[0]) ? { backgroundImage: 'url(' + product.gallery[0].directus_files_id.data.thumbnails[5].url + ')' } : '')
                          }, null, 4),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("p", _hoisted_9, _toDisplayString(product.name), 1),
                            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.formatPrice(product.price)), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.isSearching)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (index) => {
                    return _createElementVNode("div", {
                      class: "productCard overflow-hidden",
                      key: index
                    }, _hoisted_14)
                  }), 64))
                ]))
              : _createCommentVNode("", true),
            (_ctx.products.length == 0 && !_ctx.isSearching)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}